export default {"src":"/_next/static/media/minus.b90219af.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};